import React from 'react';

import { TYPES } from 'envs';
import { excludedGrandParentIds } from 'core/constants';
import { useContextMatchParams } from 'contexts/matchParams';
import { useContextProperties } from 'contexts/properties';
import { getPlace } from '../../dataProvider';
import ElTabs from '../../components/elTabs';

import './style.scss';
import Module from './module';

import ButtonGenerator from './buttonGenerator';
import ModuleGeneratorHeader from './header';

import { PlaceSelector } from './placesSelector/placeSelector';
import { MODULE_TYPES } from './utils';

const ModuleGenerator = () => {
  const { matchParams, setParams } = useContextMatchParams();
  const { params } = useContextProperties();

  // eslint-disable-next-line no-unused-vars
  const { type, electionNumber, site } = matchParams;

  const modules =
    params.sites[matchParams.site].generator.tabs[matchParams.type]?.[
      matchParams.currentPlace?.typePlace
    ] ||
    params.sites[matchParams.site].generator.tabs[matchParams.type]?.commons;

  const { generator } = params.sites[site || 'antena3'];

  const generatorTabs =
    generator.tabs[type]?.[matchParams.currentPlace?.typePlace] ||
    generator.tabs[type]?.commons;
  const getPlacesId = ({ id, name }) => {
    if (!matchParams[name]) {
      return id;
    }
    if (matchParams[name]?.split('-').length < 4) {
      return `${id}-${matchParams[name]}`;
    }
    return matchParams[name];
  };

  const changeLocation = location => {
    if (location.town) {
      if (matchParams.type === TYPES.MUNICIPAL) {
        setParams({
          ...matchParams,
          allMap: 0,
          town: location.town.ineId,
          province: location.town.parentId,
          placeId: location.town.ineId,
          community: location.town.grandpaId
        });
      } else {
        setParams({
          ...matchParams,
          allMap: 0,
          town: location.town.ineId,
          province: location.town.parentId,
          community: location.town.grandpaId
        });
      }
    } else if (location.province) {
      if (matchParams.type === TYPES.MUNICIPAL) {
        getPlace({
          filter: `sortby=main&size=1&typeplace=TOWN&parentid=${location.province.ineId}`,
          type,
          electionType: type
        }).then(p => {
          setParams({
            ...matchParams,
            allMap: 0,
            province: null,
            community: null,
            town: null,
            placeId: p.content[0].ineId,
            placesId: getPlacesId({ id: p.content[0].ineId, name: 'placesId' }),
            resultPlacesId: getPlacesId({
              id: p.content[0].name,
              name: 'resultPlacesId'
            })
          });
        });
      } else {
        setParams({
          ...matchParams,
          allMap: 0,
          province: location.province.ineId,
          community: location.province.parentId,
          town: null
        });
      }
    } else if (location.region) {
      setParams({
        ...matchParams,
        community: location.region.ineId,
        province: null,
        town: null,
        placeId: location.region.ineId,
        placesId: getPlacesId({ id: location.region.ineId, name: 'placesId' }),
        resultPlacesId: getPlacesId({
          id: location.region.name,
          name: 'resultPlacesId'
        })
      });
    } else {
      setParams({
        ...matchParams,
        community: null,
        province: null,
        town: null
      });
    }
  };

  return (
    <div className="GenerateIframePage">
      <ModuleGeneratorHeader />
      {modules.some(
        module =>
          module.component === MODULE_TYPES.HOME_NOT_CENTRALIST && module.active
      ) && (
        <div>
          {matchParams.type === TYPES.GENERAL ? (
            <button
              className="button title current"
              type="button"
              style={{ marginTop: '20px' }}
              onClick={() => {
                setParams({
                  ...matchParams,
                  community: '',
                  province: '',
                  town: '',
                  placeId: '',
                  ineId: '',
                  resultPlacesId: '',
                  allMap: 1
                });
              }}
            >
              Ir a España
            </button>
          ) : (
            <>
              <div>
                <h4>Lugares seleccionados para el módulo NO CENTRALISTA: </h4>
                <h5>{matchParams.resultPlacesId}</h5>
              </div>
              <button
                className="button title current"
                type="button"
                onClick={() => {
                  setParams({
                    ...matchParams,
                    placesId: undefined,
                    resultPlacesId: undefined
                  });
                }}
              >
                Reset No Centralist
              </button>
            </>
          )}
        </div>
      )}

      <PlaceSelector
        grid={`bottom-space `}
        type={matchParams.type}
        excludeRegions={
          matchParams.type === TYPES.REGIONAL ? excludedGrandParentIds : []
        }
        onChange={loc => changeLocation(loc)}
        lastSelection={currentPlace => {
          setParams({
            ...matchParams,
            currentPlace
          });
        }}
      />
      <div>
        <h3>{` Módulos`}</h3>
        {matchParams.currentPlace || matchParams.type === TYPES.GENERAL ? (
          <ElTabs
            titles={generatorTabs
              .filter(tab => tab.active)
              .map(tab => tab.title)}
          >
            {generatorTabs
              .filter(tab => tab.active)
              .map(tab => {
                if (tab.component === MODULE_TYPES.BUTTONS) {
                  return (
                    <ButtonGenerator
                      key={tab.component}
                      electionType={matchParams.type}
                      currentPlace={matchParams.currentPlace}
                      year={matchParams.year}
                      electionNumber={electionNumber}
                    />
                  );
                }
                if (tab.component === MODULE_TYPES.HOME_NOT_CENTRALIST) {
                  return (
                    <>
                      {matchParams?.placesId ? (
                        <Module
                          key={tab.component}
                          componentType={tab.component}
                        />
                      ) : (
                        <>No hay lugar NO CENTRALISTA seleccionado</>
                      )}
                    </>
                  );
                }
                return (
                  <Module key={tab.component} componentType={tab.component} />
                );
              })}
          </ElTabs>
        ) : (
          <>No hay lugar seleccionado</>
        )}
      </div>
    </div>
  );
};

export default ModuleGenerator;
